/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

function normalizeShopUids(payload) {
  if (Array.isArray(payload?.shopUids)) return payload.shopUids;
  if (payload?.shopUids) return [String(payload.shopUids)];
  if (Array.isArray(payload?.shopUid)) return payload.shopUid;
  if (payload?.shopUid) return [String(payload.shopUid)];
  return [];
}

export const useDashboardStore = defineStore("dashboard", {
  actions: {
    async dashboardInfoFetch(payload) {
      const body = {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        shopUids: normalizeShopUids(payload),
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-rpt-svc/dashboard/info";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async dashboardDueFetch(payload) {
      const body = {
        dueDate: payload.dueDate,
        shopUid: payload.shopUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/dashboard/due";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async overdueListFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          lastOpenDate: payload.lastOpenDate,
          shopUid: payload.shopUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/dashboard/overdue/list";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async redeemReportFetch(payload) {
      const body = {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        shopUid: payload.shopUid,
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/dashboard/redeem/report";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
    async listPaymentAllFetch(payload) {
      const body = {
        page: {
          index: payload.index,
          size: payload.size,
          sort: "",
        },
        filter: {
          groupUid: payload.groupUid,
          shopUid: payload.shopUid,
        },
      };
      return new Promise((resolve, reject) => {
        try {
          const pathUrl = "/pawn-svc/workItem/list/payment/all";
          const response = http.post(pathUrl, body);
          resolve(response);
        } catch (e) {
          reject(e);
        }
      });
    },
  },
});
